module.exports = __webpack_public_path__ + "static/img/4_5_1.e7c8d052.jpg";